import React from 'react'
import { Modal, Button, Row, Col } from 'antd'

import imgLogo from 'assets/spiffme_600px.png'
import './styles.css'

const UserTypeDialog = ({visible, close, mode, ...props}) => {

  const onSalesRep = () => {
    close()
    props.onSalesRep()
  }

  const onManufacturer = () => {
    close()
    props.onManufacturer()
  }

  const onUser = () => {
    close()
    props.onUser()
  }

  return (
    <Modal
      wrapClassName="vertical-center-modal"
      visible={visible}
      footer={null}
      onCancel={close}
    >
      <Row className="usertype">
        <Col span={24}>
          <img className="logo" src={imgLogo} alt="logo" />
          <p className="description">
            The Premier Single-Source <br />Spiff/Referral Management System
          </p>
        </Col>

        { mode === 'SIGNIN' &&
          <div>
            <Col span={24}>
              <Button className="button" ghost onClick={onSalesRep}>Sales Rep</Button>
            </Col>
            <Col span={24}>
              <Button className="button" ghost onClick={onUser}>Company</Button>
            </Col>
          </div>
        }
        { mode === 'SIGNUP' &&
          <Col span={24}>
            <div className="signup">
              <div className="signup-type">
                <div className="button-description"><b>Spiffee</b> - I want to make money referring business and/or selling the same products that I already sell for a living.</div>
                <Button className="button" ghost onClick={onSalesRep}>Spiffee - Sign Me Up</Button>
              </div>

              {/* <Col span={24}>
                <Button className="button" ghost onClick={onUser}>Sign Up with a Manufacturer</Button>
              </Col> */}
              <div className="signup-type">
                <div className="button-description"><b>Spiffer</b> - I am a Company or Salesperson and I want to incentivize sales/referrals without increasing my costs.</div>
                <Button className="button" ghost onClick={onManufacturer}>Spiffer - Sign Me Up</Button>
              </div>
            </div>
          </Col>
        }
      </Row>
    </Modal>
  )
}

export default UserTypeDialog
